import { Component, OnInit, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { MyDocsService } from '../../service/mydocs.service';
import { MyDocsModel } from '../../models/upload/mydocs.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { Observable, Subscription } from 'rxjs';
import { NotificationType } from '../../enum/notification-type.enum';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormControl, NgForm } from '@angular/forms';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { Buttons } from 'src/app/home/table/Buttons';
import { GlobalService } from 'src/app/service/global.service';
import { ApprovalFlowService } from 'src/app/admin-portal/approval-flow-models/approval-flow.service';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { WorkflowTicket } from 'src/app/admin-portal/approval-flow-models/workflow-ticket.model';

@Component({
  selector: 'app-view-user-doc',
  templateUrl: './view-user-doc.component.html',
  styleUrls: ['./view-user-doc.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class ViewUserDocComponent implements OnInit {

  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public loggedinUser: string = '';
  public commPlanDescData: MyDocsModel[] = [];
  public employeesData: MyDocsModel[] = [];
  public rolesData: MyDocsModel[] = [];
  public res: MyDocsModel[] = [];
  public selectedEmpsPushData: MyDocsModel[] = [];
  public excelAssignedDocsList: MyDocsModel[] = [];
  public checkedactive: boolean = false;
  public showLoading: boolean;
  public showProgress: boolean;
  public mySalesChannelSet = new Set<string>();
  public isEmpShown: boolean = false;
  public masterSelected: boolean;
  public expandedElement: null;
  public utype: string;
  public myDocsModel = new MyDocsModel();
  public myDocsModel1 = new MyDocsModel();
  public dataSource = new MatTableDataSource<MyDocsModel>();
  public dataSourceEmp = new MatTableDataSource<MyDocsModel>();
  public workflowTicketsData = new WorkflowTicket();
  public displayedColumns = ['comm_plan_desc', 'user_type', 'effective_dt'];
  public displayedColumnsEmp = ['select', 'employeeId', 'employeeName'];
  public filteredComPlanOptions: Observable<any[]>;
  public myControl = new FormControl();
  public trackingid: string = "";
  public resdata: any;

  @ViewChild('mainSort') mainSort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  @ViewChild('empSort') empSort: MatSort;
  @ViewChild('empPaginator') empPaginator: MatPaginator;
  @ViewChild('TABLE1') table1: ElementRef;

  // START ====================================================
  @Output() result = new EventEmitter<{ key: string, data: Array<string> }>();
  @Input() placeholder: string = 'Select Employee';
  @Input() data: Array<MyDocsModel> = [];
  @Input() key: string = '';

  public selectControl = new FormControl();
  public rawData: Array<MyDocsModel> = [];
  public selectData: Array<MyDocsModel> = [];
  public filteredData: Observable<Array<MyDocsModel>>;
  public usersData: MyDocsModel[] = [];
  public filterString: string = '';
  public selectedEmpIds: string = "";
  public assignedDocsData: MyDocsModel[] = [];
  public assignedDocsExpandData: MyDocsModel[] = [];

  // END ====================================================

  // GRID FRAMEWORK
  public ordersTableColumns1: TableColumn[];
  public ordersTableColumns2: TableColumn[];
  public columnsData: any;
  public buttons: Buttons[];
  public actions: any;
  public checkbox: any;
  public actionButtons: any;
  public columnsExcelData: any;
  public dataForExcel = [];
  public ordersTableExcelHeaderColumns: TableColumn[];
  public isAccessDisabled: boolean = false;

  filteredEmpValues: Observable<MyDocsModel[]> | undefined;
  controlSup = new FormControl();

  constructor(private globalService: GlobalService, private router: Router, private myDocsService: MyDocsService,
    private httpService: HttpClient, private authGaurdService: AuthGaurdService, private notificationService: NotificationService,
    public ete: ExportExcelService, private approvalFlowService: ApprovalFlowService) {
    this.getComPlanData();
  }

  ngOnInit(): void {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('user-doc-mapping');
    this.myDocsModel = this.myDocsService.myDocsModel;
    this.mySalesChannelSet = this.myDocsService.mySalesChannelSet;
    this.myDocsModel.id = this.myDocsService.myDocsModel.id;
    this.myDocsModel.doc_desc = this.myDocsService.myDocsModel.doc_desc;
    this.filterEmployees();
    this.initializeColumns();
    this.getAssignedDocsList(this.myDocsModel.id);
    this.getUserTypesList();
    this.initializeExcelHeaders();
    this.getExcelAssignedDocsList(this.myDocsModel.doc_desc);
  }

  filterEmployees() {
    console.log("filterEmployeess called");
    this.filteredEmpValues = this.controlSup.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSup(value))
    );
  }

  private _filterSup(value: string): MyDocsModel[] {
    console.log("inside _filterSup() = " + value);
    const filterValue = this._normalizeValue(value);

    if (value) {
      console.log("inside IF " + value);
      this.myDocsService.getEmployees(value,this.myDocsModel.user_type, this.myDocsModel.doc_desc, this.myDocsModel.comm_plan_id).subscribe(
        (response: MyDocsModel[]) => {
          console.log("response = " + JSON.stringify(response));
          this.usersData = response;
          this.rawData = response;
          //this.rawData = response;
          //console.log("this.rawData = " + JSON.stringify(this.rawData));

          // this.filteredData = this.selectControl.valueChanges.pipe(
          //   startWith<string>(''),
          //   map(value => typeof value === 'string' ? value : this.filterString),
          //   map(filter => this.filter(filter))
          // );
          //console.log(this.filteredData);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      );
    }
    return this.usersData.filter(item => this._normalizeValue(item.employeeName).includes(filterValue));
  }

  private _normalizeValue(value: string): string {
    return value.toString().toLowerCase().replace(/\s/g, '');
  }

  public onChangeGetEmployees(event) {
    this.myDocsModel.user_type = event.target.value;
    //this.clickButton('openPopUp');
    //console.log("this.myDocsModel.comm_plan_id = " + this.myDocsModel.comm_plan_id);
    if (this.myDocsModel.comm_plan_id === 0 || this.myDocsModel.comm_plan_id === "") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Commission Plan');
    } else if (this.myDocsModel.doc_desc === "") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Document not available');
    } else {
      //this.getEmployees(this.myDocsModel.user_type);
      this.filterEmployees();
    }
  }

  // public getEmployees(filter: string): void {
  //   console.log("inside getEmployees===" + filter);
  //   this.myDocsService.getEmployees(filter, this.myDocsModel.doc_desc, this.myDocsModel.comm_plan_id).subscribe(
  //     (response: MyDocsModel[]) => {
  //       console.log("response = " + JSON.stringify(response));
  //       this.data = response;
  //       this.rawData = response;
  //       //console.log("this.rawData = " + JSON.stringify(this.rawData));

  //       this.filteredData = this.selectControl.valueChanges.pipe(
  //         startWith<string>(''),
  //         map(value => typeof value === 'string' ? value : this.filterString),
  //         map(filter => this.filter(filter))
  //       );
  //       //console.log(this.filteredData);
  //     }, (errorResponse: HttpErrorResponse) => {
  //       var msg: any;
  //       msg = errorResponse;
  //       this.notificationService.sendNotification(NotificationType.ERROR, msg);
  //     }
  //   )
  // }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.assignedDocs;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    console.log(this.excelAssignedDocsList);
    for (let js of this.excelAssignedDocsList) {
      delete js.id;
      delete js.comm_plan_id;
      delete js.doc_name;
      delete js.doc_desc;
      delete js.comm_doc_str;
      delete js.status;
      delete js.editMode;
      delete js.created_dt;
      delete js.comm_doc;
      delete js.comm_plan_id;
      delete js.employeesList;
      delete js.created_by;
      delete js.selected;
      delete js.updated_by;
      delete js.comment;
      delete js.updated_dt;
      delete js.sc_emp_id;
    }
    console.log(this.excelAssignedDocsList);
    this.dataForExcel = [];
    let reportData = null;
    this.excelAssignedDocsList.forEach((row: any) => {
      //console.log("obj === " + Object.values(row));
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'AssignedDocs',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  public getAssignedDocsList(docid: any): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.myDocsService.getAssignedDocsList(docid).subscribe(
        (response: MyDocsModel[]) => {
          console.log(JSON.stringify(response));
          //this.dataSource.data = response as MyDocsModel[];
          this.assignedDocsData = response;
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getAssignedDocsExpandList(docid: any, comm_plan_id: number, user_type: string,effective_dt:any): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.myDocsService.getAssignedDocsExpandList(docid, comm_plan_id, user_type,effective_dt).subscribe(
        (response: MyDocsModel[]) => {
          //this.dataSource.data = response as MyDocsModel[];
          this.assignedDocsExpandData = response;
          console.log(this.assignedDocsExpandData);
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getExcelAssignedDocsList(doc_desc: string): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.myDocsService.getExcelAssignedDocsList(doc_desc).subscribe(
        (response: MyDocsModel[]) => {
          this.excelAssignedDocsList = JSON.parse(JSON.stringify(response));
          console.log(JSON.stringify(this.excelAssignedDocsList));
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getComPlanData() {
    this.filteredComPlanOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val => {
        return this.getCommPlanDescList(val || '')
      })
    )
  }

  public getCommPlanDescList(val: string): Observable<any[]> {
    //console.log("One one");
    return this.myDocsService.getCommPlanDescList()
      .pipe(
        map(response => response.filter(option => {
          this.res = response;
          console.log("res === "+this.res);
          return option.comm_plan_desc.toLowerCase().indexOf(val.toLowerCase()) === 0
        }))
      )
  }

  public getSelectedCommPlan(desc: string) {
    //console.log("Two two");
    this.getComPlanData();
    console.log(this.res);
    if(this.res){
      return this.res.find(commdesc => commdesc.comm_plan_id === desc).comm_plan_desc;
    }else{
      return null;
    }
    
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.employeesData.every(function (item: any) {
      console.log("Edit Mode: isAllSelected");
      return item.editMode == true;
    })
    this.getCheckedItemList();
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.employeesData.length; i++) {
      this.employeesData[i].editMode = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Get List of Checked Items
  getCheckedItemList() {
    this.selectedEmpsPushData = [];

    for (var i = 0; i < this.employeesData.length; i++) {
      if (this.employeesData[i].editMode) {
        this.myDocsModel1 = this.employeesData[i];
        this.myDocsModel1.comm_plan_id = this.myDocsModel.comm_plan_id;
        this.myDocsModel1.user_type = this.myDocsModel.user_type;
        this.myDocsModel1.effective_dt = this.myDocsModel.effective_dt;
        this.myDocsModel1.id = this.myDocsModel.id;
        this.selectedEmpsPushData.push(this.myDocsModel1);
      }
    }
    //this.selectedEmpsPushData = JSON.stringify(this.selectedEmpsPushData);
    console.log("getCheckedItemList this.selectedEmpsPushData = " + JSON.stringify(this.selectedEmpsPushData));
  }

  public onAssign(assignForm: NgForm): void {
    if (this.myDocsModel.comm_plan_desc === "" || this.myDocsModel.comm_plan_desc === "0") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select commission plan');
    } else if (this.myDocsModel.effective_dt === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select effective date');
    } else if (Object.keys(this.selectData).length === 0) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select employee/s');
    } else {
      this.showLoading = true;
      //this.selectData[0].tracking_id=this.trackingid;
      console.log(this.selectData);
      this.myDocsService.assignDocToEmployees(this.selectData)
        .subscribe(response => {

          this.showLoading = false;
          this.clickButton('closeModalButton');
          this.getAssignedDocsList(this.myDocsModel.id);
          this.selectData = [];
          this.ngOnInit();
          this.notificationService.notify(NotificationType.SUCCESS, `Document assigned successfully`);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    }
  }





  public onDeleteEmp(id: number, employeeId: string): void {
    if (confirm("Are you sure to delete this assigned employee")) {
      this.subscriptions.push(
        this.myDocsService.deleteEmp(id, employeeId).subscribe(
          (response: CustomHttpRespone) => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
            this.getAssignedDocsList(this.myDocsModel.id);
           // this.getEmployees(this.utype);
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
      );
    }
  }

  public getUserTypesList(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.myDocsService.getUserTypesList().subscribe(
        (response: MyDocsModel[]) => {
          this.rolesData = response;
          this.rolesData = this.rolesData.sort((a, b) => (a.user_type < b.user_type) ? -1 : 1);
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  // START =====================================================================================================
  filter = (filter: string): Array<MyDocsModel> => {
    //this.getEmployees(filter);

    // console.log("inside filter===" + filter);
    this.filterString = filter;
    //console.log("filter.length = " + filter.length);
    if (filter.length > 2) {
      return this.rawData.filter(option => {
        return option.employeeName.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    } else {
      return this.rawData.slice();
    }
  };

  //displayFn = (): string => '';

  public displayFunction(distri: string) {
    console.log("distri === " + distri);
    return this.rawData.find(distribute => distribute.employeeId === distri).employeeName;
  }

  optionClicked = (event: Event, data: MyDocsModel): void => {
    event.stopPropagation();
    this.toggleSelection(data);
  };

  toggleSelection = (data: MyDocsModel): void => {
    console.log(data);
    data.selected = !data.selected;
    console.log(this.myDocsModel);
    console.log(this.myDocsModel.effective_dt);
    if (data.selected === true) {
      data.comm_plan_id = this.myDocsModel.comm_plan_id;
      data.user_type = this.myDocsModel.user_type;
      data.effective_dt = this.myDocsModel.effective_dt;
      data.id = this.myDocsModel.id;
      data.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.selectData.push(data);
    } else {
      const i = this.selectData.findIndex(value => value.employeeName === data.employeeName);
      this.selectData.splice(i, 1);
    }

    this.selectControl.setValue(this.selectData);
    this.emitAdjustedData();
  };

  emitAdjustedData = (): void => {
    const results: Array<string> = []
    var rest: string = "";
    console.log("this.selectData===" + JSON.stringify(this.selectData));
    this.selectData.forEach((data: MyDocsModel) => {
      rest = rest + data.employeeId + ",";
      this.selectedEmpIds = rest.slice(0, -1);
      this.myDocsModel.employeeId = this.selectedEmpIds;
      results.push(data.employeeName);
    });
    this.result.emit({ key: this.key, data: results });
    console.log("this.result===" + JSON.stringify(this.result));
  };

  removeChip = (data: MyDocsModel): void => {
    this.toggleSelection(data);
  };

  // END =============================================================================================

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  // GRID FRAMEWORK
  innerRowAction1(row: any) {
    if (row.value === 'View') {
      console.log(this.myDocsModel.doc_desc);
      console.log(row.row.comm_plan_id);
      console.log(row.row.user_type);
      this.getAssignedDocsExpandList(this.myDocsModel.id, row.row.comm_plan_id, row.row.user_type, row.row.effective_dt);
    }
  }

  innerRowAction2(row: any) {
    if (row.value === 'Delete') {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.onDeleteEmp(row.row.id, row.row.employeeId);
      }

    }
  }

  actionOnButton(action: any) {
    if (action === "Assign") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }

    }
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns2 = this.columnsData.userDocMappingExpand;
        this.ordersTableColumns1 = this.columnsData.userDocMappingView;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    this.actions = [
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }
    ]

    this.buttons = [
      {
        name: 'Back',
        pagenavigation: 'user-doc-mapping'
      }
    ];

    this.actionButtons = [
      {
        name: 'Assign',
        class: 'btn btn-primary btn-xs'
      }
    ]

  }
}